/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { NumericSearch } from './NumericSearch';
import {
    NumericSearchFromJSON,
    NumericSearchFromJSONTyped,
    NumericSearchToJSON,
} from './NumericSearch';
import type { StringListSearch } from './StringListSearch';
import {
    StringListSearchFromJSON,
    StringListSearchFromJSONTyped,
    StringListSearchToJSON,
} from './StringListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface DashboardAbsenceWalterSearch
 */
export interface DashboardAbsenceWalterSearch {
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof DashboardAbsenceWalterSearch
     */
    idcentre?: Int32ListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof DashboardAbsenceWalterSearch
     */
    degre?: StringListSearch;
    /**
     * 
     * @type {StringListSearch}
     * @memberof DashboardAbsenceWalterSearch
     */
    metierStade?: StringListSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof DashboardAbsenceWalterSearch
     */
    codeClasse?: TextSearch;
    /**
     * 
     * @type {NumericSearch}
     * @memberof DashboardAbsenceWalterSearch
     */
    absencesInjustifiees?: NumericSearch;
    /**
     * 
     * @type {boolean}
     * @memberof DashboardAbsenceWalterSearch
     */
    hideMasquees?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof DashboardAbsenceWalterSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof DashboardAbsenceWalterSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardAbsenceWalterSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DashboardAbsenceWalterSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof DashboardAbsenceWalterSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof DashboardAbsenceWalterSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the DashboardAbsenceWalterSearch interface.
 */
export function instanceOfDashboardAbsenceWalterSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardAbsenceWalterSearchFromJSON(json: any): DashboardAbsenceWalterSearch {
    return DashboardAbsenceWalterSearchFromJSONTyped(json, false);
}

export function DashboardAbsenceWalterSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardAbsenceWalterSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idcentre': !exists(json, 'idcentre') ? undefined : Int32ListSearchFromJSON(json['idcentre']),
        'degre': !exists(json, 'degre') ? undefined : StringListSearchFromJSON(json['degre']),
        'metierStade': !exists(json, 'metierStade') ? undefined : StringListSearchFromJSON(json['metierStade']),
        'codeClasse': !exists(json, 'codeClasse') ? undefined : TextSearchFromJSON(json['codeClasse']),
        'absencesInjustifiees': !exists(json, 'absencesInjustifiees') ? undefined : NumericSearchFromJSON(json['absencesInjustifiees']),
        'hideMasquees': !exists(json, 'hideMasquees') ? undefined : json['hideMasquees'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function DashboardAbsenceWalterSearchToJSON(value?: DashboardAbsenceWalterSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idcentre': Int32ListSearchToJSON(value.idcentre),
        'degre': StringListSearchToJSON(value.degre),
        'metierStade': StringListSearchToJSON(value.metierStade),
        'codeClasse': TextSearchToJSON(value.codeClasse),
        'absencesInjustifiees': NumericSearchToJSON(value.absencesInjustifiees),
        'hideMasquees': value.hideMasquees,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

